import BillingItemsListApp from './BillingItemsListApp';

export default BillingItemsListApp;
